export default __webpack_public_path__ + "static/media/ghl.87230627.png";